import { request } from '~/utils/request'

export const actions = {
  async fetchList({ state }, { postcode }) {
    const { data } = await request(this).get('/towns', null, { postcode })
    return data
  },
}
